// Mount the Oss module: hand `createOssModule` a lazy host (`./oss-host`, which holds the heavy app
// imports) instead of a built one. `service-modules.ts` and `service-scopes.ts` take the routes and
// the catalog scopes from HERE, so the module cannot be mounted unregistered; the catalog detail page
// reaches the storage landing through `catalogLandings` (a page may not import this file). This file must stay light: it is in the entry chunk. The HTTP client is not
// a member: the module reads it from the shared registry (`@vnetwork/margarita-core/http`).
import { createOssModule } from '@vnetwork/margarita-oss';
import { catalogLandings } from '@/components/catalog-landings';

export const oss = createOssModule(() => import('./oss-host').then((m) => m.ossHost));

catalogLandings.loadStorageLanding = oss.loadStorageLanding;
